import { createApp } from 'vue';

import unitsSearch from '@/components/UnitsSearch.vue';
import i18n from '@/locales';

const app = createApp({});
app.use(i18n);
app.component('UnitsSearch', unitsSearch);
app.mount('#unitsSearchApp');